'use strict';

module Patersons {

    export interface TaxFileNumberScope extends ng.IScope {
        taxFileNumberForm: ng.IFormController;
        parentController: AbstractController;
        accounts: Array<Account>;
        selectedAccount: Account;
        taxFileNumber: string;
        taxFileNumberType: string;
        events: Patersons.TaxFileNumberViewCtrl;
        date: Date;
        isLoading: boolean;
        url: String;
        errorHandler: any;
        isSubmitted: boolean;
        isBusy: boolean;
        scrollDuration: number;
    }

    export class TaxFileNumberViewCtrl extends AccountBaseCtrl {
        scope: Patersons.TaxFileNumberScope;
        portfolioService: Patersons.PortfolioService;
        document: any;

        static $inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'portfolioService', 'navigationService'];

        constructor($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, portfolioService, navigationService) {
            super($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.taxFileNumber = '';
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.isSubmitted = false;
            this.scope.isBusy = false;
            this.scope.events = this;

            this.document = $document;
            this.scope.scrollDuration = 700;

            this.load();

        }

        setSelectedAccount(accountId: string) {
            this.scope.selectedAccount = this.scope.accounts.filter(a => a.accountId == accountId)[0];
        };

        load() {
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then((result: Array<Account>) => {
                this.scope.accounts = result;
                if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
                    this.scope.selectedAccount = this.scope.accounts[0];
                }
            },(reason) => {
              this.scope.errorHandler = reason.data;
            });
        }

        saveTaxFileNumber() {
            this.scope.$broadcast('show-errors-check-validity');

            if (this.scope.taxFileNumberForm.$invalid) {
                return;
            }

            if (this.scope.selectedAccount === undefined) {
                return;
            }

            this.scope.isBusy = true;

            var promise: ng.IHttpPromise<any> = this.portfolioService.updateTaxFileNumber(this.scope.selectedAccount.accountId, this.scope.taxFileNumber, this.scope.taxFileNumberType);
            promise.then((result) => {
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                this.scope.isSubmitted = true;
                return;
            },
                (reason) => { // error handling
                    this.scope.errorHandler = reason.data;
                })
                .finally(() => {
                    this.scope.isBusy = false;
                });
        }
    }
}
